import React from "react";
import { classes } from "@bloomberg/media-ui-core";
import styles from "./sectionTitle.module.css";

type SectionTitleProps = {
  text: string;
  className?: string;
};

export default function SectionTitle({ text, className }: SectionTitleProps) {
  return <h3 className={classes([styles.sectionTitle, className])}>{text}</h3>;
}
